<template>
  <DefaultPage>
    <div class="home-hero">
      <div class="hero hero-tall">
        <PillsRandom
          hero
          context="home"
          :columns="20"
          :overflowAtColumn="10"
          :style="{ left: '50%' }"
        />
        <div class="hero-flex-wrap">
          <div class="grid-container">
            <div class="hero__call">
              <div class="hero-part">
                <div class="hero__tagline">
                  The 2022 Annual Report
                </div>
                <h1 class="hero__headline">
                  Created <span class="text-light-blue italic-light">by</span> doctors<br /><span class="text-light-blue italic-light">for</span> doctors
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      <HomeHeroVideo/>
    </div>
    <HomeLetter/>
    <div class="footer-pills">
      <PillsRandom
        :columns="40"
        :density="25"
        animated
      />
    </div>
  </DefaultPage>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import HomeHeroVideo from '@/components/home/HomeHeroVideo';
import HomeLetter from '@/components/home/HomeLetter';
import PillsRandom from '@/components/pills/PillsRandom';

export default {
  name: 'Home',
  components: {
    HomeLetter,
    HomeHeroVideo,
    DefaultPage,
    PillsRandom
  }
};
</script>
